export type Drama = {
  id: string;
  title: string;
  poster: string;
  backdrop: string;
  category: string;
  categoryName: string;
  genres: string[];
  region: string;
  year: number;
  status: string;
  episodes: number;
  updatedTo: number;
  updateInfo: string;
  updatedAt: string;
  rating: number;
  heat: number;
  starring: string[];
  director: string;
  tagline: string;
  synopsis: string;
  featured: boolean;
};

export const categories = [
  { slug: 'guochan', name: '国产剧', desc: '大陆最新的古装、都市、悬疑与年代剧集，紧跟国内卫视与平台热播动态。' },
  { slug: 'hanju', name: '韩剧', desc: '韩国最新爱情、家庭与悬疑剧集，收录人气演员阵容与每周更新进度。' },
  { slug: 'meiju', name: '美剧', desc: '美国最新犯罪、科幻与剧情大剧，追踪高分口碑与季播更新节奏。' },
  { slug: 'guzhuang', name: '古装剧', desc: '历史权谋、武侠江湖与宫廷传奇，服化道考究的古装大剧集合。' },
  { slug: 'dushi', name: '都市剧', desc: '都市情感、职场励志与轻喜剧，贴近现实生活的当代题材剧集。' },
];

export const dramas: Drama[] = [
  {
    id: 'd001',
    title: '长夜黎明',
    poster:
      'https://readdy.ai/api/search-image?query=Cinematic%20poster%20of%20a%20lone%20strategist%20in%20dark%20blue%20ancient%20Chinese%20armor%20standing%20under%20a%20cold%20moonlit%20sky%2C%20dramatic%20rim%20light%2C%20deep%20navy%20and%20amber%20color%20grading%2C%20minimal%20textured%20background%2C%20moody%20epic%20historical%20drama%20aesthetic%2C%20high%20detail%20film%20composition&width=600&height=900&seq=drama-poster-d001&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=Epic%20cinematic%20still%20of%20an%20ancient%20Chinese%20palace%20courtyard%20at%20night%20with%20glowing%20lanterns%2C%20dark%20blue%20misty%20atmosphere%20and%20warm%20amber%20accent%20light%2C%20silhouettes%20of%20armored%20guards%2C%20wide%20angle%20dramatic%20film%20composition%2C%20moody%20historical%20drama%20key%20art&width=1600&height=900&seq=drama-backdrop-d001&orientation=landscape',
    category: 'guochan',
    categoryName: '国产剧',
    genres: ['古装剧', '权谋', '历史'],
    region: '大陆',
    year: 2025,
    status: '连载中',
    episodes: 40,
    updatedTo: 24,
    updateInfo: '每周三至周五 20:00 更新 2 集',
    updatedAt: '2026-10-12',
    rating: 8.6,
    heat: 9820000,
    starring: ['张湛', '李桐', '王劲松'],
    director: '陈凯',
    tagline: '一局跨越二十年的棋，只为等来黎明。',
    synopsis:
      '乱世末年，身负家仇的谋士沈砚隐姓埋名潜入朝堂，在权臣与皇权的夹缝中步步为营。他一边以过人的智谋化解连番危机，一边寻找当年灭门真相。当棋局走到最后一步，他才发现真正要守护的，是整个王朝的黎明。',
    featured: true,
  },
  {
    id: 'd002',
    title: '星辰之约',
    poster:
      'https://readdy.ai/api/search-image?query=Romantic%20cinematic%20poster%20of%20a%20young%20woman%20and%20man%20reaching%20toward%20a%20glowing%20star%20field%2C%20soft%20blue%20night%20sky%20with%20warm%20amber%20highlights%2C%20dreamy%20ethereal%20lighting%2C%20minimal%20clean%20background%2C%20Korean%20fantasy%20romance%20drama%20key%20art%2C%20elegant%20and%20emotional%20mood&width=600&height=900&seq=drama-poster-d002&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=Dreamy%20wide%20cinematic%20scene%20of%20a%20starry%20night%20sky%20over%20a%20quiet%20seaside%20town%20with%20distant%20city%20lights%2C%20deep%20blue%20tones%20with%20soft%20orange%20glow%20on%20the%20horizon%2C%20romantic%20fantasy%20drama%20key%20visual%2C%20gentle%20atmospheric%20lighting%2C%20film%20still%20composition&width=1600&height=900&seq=drama-backdrop-d002&orientation=landscape',
    category: 'hanju',
    categoryName: '韩剧',
    genres: ['爱情', '奇幻', '治愈'],
    region: '韩国',
    year: 2025,
    status: '连载中',
    episodes: 16,
    updatedTo: 10,
    updateInfo: '每周六、周日各更新 1 集',
    updatedAt: '2026-10-11',
    rating: 8.9,
    heat: 12400000,
    starring: ['韩瑞妍', '朴志勋', '金多顺'],
    director: '柳承浩',
    tagline: '如果星星记得，我们的约定就永远不会消失。',
    synopsis:
      '天文台研究员秀雅在一次观测中遇见了自称来自十年后的神秘男子。两人因一颗即将消失的彗星而相遇，也因这段跨越时间的缘分被迫面对离别。他们约定，无论相隔多远，都要在同一片星空下重逢。',
    featured: true,
  },
  {
    id: 'd003',
    title: '迷雾档案',
    poster:
      'https://readdy.ai/api/search-image?query=Dark%20crime%20thriller%20poster%20of%20a%20detective%20in%20a%20long%20coat%20standing%20in%20a%20foggy%20alley%20at%20night%2C%20deep%20blue%20shadows%20with%20a%20single%20amber%20streetlight%2C%20gritty%20cinematic%20mood%2C%20minimal%20textured%20backdrop%2C%20American%20crime%20drama%20key%20art%2C%20high%20contrast%20lighting&width=600&height=900&seq=drama-poster-d003&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=Atmospheric%20crime%20thriller%20scene%20of%20a%20rain-soaked%20city%20street%20at%20night%20with%20fog%20and%20blurred%20neon%20reflections%2C%20deep%20blue%20tones%20with%20warm%20orange%20highlights%2C%20cinematic%20wide%20shot%2C%20suspenseful%20film%20still%2C%20moody%20noir%20composition&width=1600&height=900&seq=drama-backdrop-d003&orientation=landscape',
    category: 'meiju',
    categoryName: '美剧',
    genres: ['悬疑', '犯罪', '剧情'],
    region: '美国',
    year: 2025,
    status: '连载中',
    episodes: 10,
    updatedTo: 6,
    updateInfo: '每周五更新 1 集',
    updatedAt: '2026-10-10',
    rating: 9.1,
    heat: 8760000,
    starring: ['艾登·科尔', '玛雅·罗兰', '德文·布莱克'],
    director: '诺亚·哈里斯',
    tagline: '每解开一个谜题，真相就更远一步。',
    synopsis:
      '资深探员卡特接手了一宗尘封十年的连环失踪案，随着调查深入，他发现所有线索都指向一个早已解散的秘密机构。当身边的人接连出事，他必须在一个被刻意掩埋的档案里，找回被抹去的真相。',
    featured: true,
  },
  {
    id: 'd004',
    title: '都市浮沉',
    poster:
      'https://readdy.ai/api/search-image?query=Modern%20urban%20drama%20poster%20of%20a%20young%20professional%20woman%20in%20a%20tailored%20coat%20standing%20before%20a%20glass%20skyscraper%2C%20cool%20blue%20city%20tones%20with%20warm%20orange%20sun%20glow%2C%20clean%20minimal%20background%2C%20contemporary%20workplace%20drama%20key%20art%2C%20confident%20and%20elegant%20mood&width=600&height=900&seq=drama-poster-d004&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=Cinematic%20city%20skyline%20at%20dusk%20with%20glass%20office%20towers%2C%20deep%20blue%20evening%20sky%20and%20warm%20orange%20window%20lights%2C%20wide%20modern%20urban%20composition%2C%20professional%20drama%20key%20visual%2C%20clean%20and%20layered%20architectural%20photography&width=1600&height=900&seq=drama-backdrop-d004&orientation=landscape',
    category: 'dushi',
    categoryName: '都市剧',
    genres: ['都市', '职场', '励志'],
    region: '大陆',
    year: 2025,
    status: '连载中',
    episodes: 36,
    updatedTo: 20,
    updateInfo: '每周一至周四 19:30 更新 1 集',
    updatedAt: '2026-10-09',
    rating: 8.2,
    heat: 7350000,
    starring: ['周芷','陆沉','林薇'],
    director: '赵宁',
    tagline: '在这座城市里，没有人是独自浮沉的。',
    synopsis:
      '来自小城的林晚进入顶级地产公司，从最底层的实习生一路打拼。面对职场算计、行业寒冬与情感抉择，她与团队一起在城市的浪潮中寻找立足之地，也重新定义了成功的意义。',
    featured: true,
  },
  {
    id: 'd005',
    title: '山河令歌',
    poster:
      'https://readdy.ai/api/search-image?query=Wuxia%20drama%20poster%20of%20a%20swordsman%20in%20flowing%20blue%20robes%20on%20a%20misty%20mountain%20ridge%2C%20cold%20blue%20palette%20with%20warm%20orange%20sunset%20accents%2C%20sweeping%20cinematic%20composition%2C%20minimal%20fog%20background%2C%20Chinese%20martial%20arts%20fantasy%20key%20art%2C%20elegant%20dynamic%20silhouette&width=600&height=900&seq=drama-poster-d005&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=Epic%20wuxia%20landscape%20of%20misty%20mountain%20peaks%20at%20sunrise%20with%20a%20lone%20swordsman%20silhouette%2C%20deep%20blue%20tones%20and%20warm%20orange%20sky%2C%20vast%20cinematic%20wide%20shot%2C%20traditional%20Chinese%20martial%20arts%20fantasy%20key%20visual%2C%20atmospheric%20and%20grand&width=1600&height=900&seq=drama-backdrop-d005&orientation=landscape',
    category: 'guzhuang',
    categoryName: '古装剧',
    genres: ['古装剧', '武侠', '江湖'],
    region: '大陆',
    year: 2024,
    status: '已完结',
    episodes: 38,
    updatedTo: 38,
    updateInfo: '全剧已完结',
    updatedAt: '2026-09-28',
    rating: 8.8,
    heat: 10200000,
    starring: ['顾云舟','苏挽','谢惊鸿'],
    director: '徐牧',
    tagline: '一曲山河令，半世江湖情。',
    synopsis:
      '江湖传言，得令者得天下。少年剑客顾云舟为报师门之仇下山，却卷入两派争夺武林秘令的漩涡。他与身世成谜的女侠苏挽并肩而行，在刀光剑影中揭开一段被掩埋的江湖往事。',
    featured: true,
  },
  {
    id: 'd006',
    title: '归途有你',
    poster:
      'https://readdy.ai/api/search-image?query=Warm%20emotional%20drama%20poster%20of%20a%20young%20couple%20walking%20on%20a%20small%20town%20road%20at%20golden%20hour%2C%20soft%20blue%20sky%20and%20warm%20orange%20sunlight%2C%20nostalgic%20film%20tone%2C%20minimal%20countryside%20background%2C%20gentle%20romance%20drama%20key%20art%2C%20tender%20and%20cinematic&width=600&height=900&seq=drama-poster-d006&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=Golden%20hour%20countryside%20road%20lined%20with%20tall%20trees%2C%20warm%20orange%20light%20and%20soft%20blue%20sky%2C%20cinematic%20wide%20composition%2C%20nostalgic%20rural%20atmosphere%2C%20emotional%20drama%20key%20visual%2C%20gentle%20and%20inviting%20film%20still&width=1600&height=900&seq=drama-backdrop-d006&orientation=landscape',
    category: 'guochan',
    categoryName: '国产剧',
    genres: ['都市', '情感', '家庭'],
    region: '大陆',
    year: 2024,
    status: '已完结',
    episodes: 32,
    updatedTo: 32,
    updateInfo: '全剧已完结',
    updatedAt: '2026-09-20',
    rating: 8.0,
    heat: 5120000,
    starring: ['许清','何嘉','孙雨'],
    director: '钱进',
    tagline: '无论走多远，家永远在归途的尽头。',
    synopsis:
      '在外漂泊多年的设计师许清因父亲病重回到故乡小城，重逢了年少时的挚友。在照顾家人与重启事业的过程中，她重新理解了亲情与梦想的重量，也找回了那个曾经勇敢的自己。',
    featured: false,
  },
  {
    id: 'd007',
    title: '首尔之夏',
    poster:
      'https://readdy.ai/api/search-image?query=Romantic%20Korean%20drama%20poster%20of%20a%20young%20couple%20under%20a%20summer%20parasol%20on%20a%20Seoul%20street%2C%20bright%20blue%20sky%20with%20warm%20orange%20sunlight%2C%20soft%20film%20grain%2C%20minimal%20urban%20background%2C%20sweet%20summery%20romance%20key%20art%2C%20fresh%20and%20youthful%20mood&width=600&height=900&seq=drama-poster-d007&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=Sunny%20Seoul%20street%20in%20summer%20with%20warm%20orange%20light%20and%20blue%20sky%2C%20cozy%20cafes%20and%20leafy%20sidewalks%2C%20cinematic%20wide%20shot%2C%20gentle%20romantic%20city%20atmosphere%2C%20Korean%20drama%20key%20visual%2C%20bright%20and%20airy&width=1600&height=900&seq=drama-backdrop-d007&orientation=landscape',
    category: 'hanju',
    categoryName: '韩剧',
    genres: ['爱情', '都市', '青春'],
    region: '韩国',
    year: 2025,
    status: '连载中',
    episodes: 14,
    updatedTo: 8,
    updateInfo: '每周二更新 1 集',
    updatedAt: '2026-10-08',
    rating: 8.4,
    heat: 6680000,
    starring: ['郑海仁','尹素熙','崔民赫'],
    director: '白恩静',
    tagline: '那年夏天，我们在首尔的街角遇见。',
    synopsis:
      '刚到首尔追梦的插画师智恩，遇见了看似冷漠的咖啡店主理人。两人因为一场误会相识，又在一次次并肩的日常里慢慢靠近。这个夏天，改变了他们对未来的全部设想。',
    featured: false,
  },
  {
    id: 'd008',
    title: '硅谷风云',
    poster:
      'https://readdy.ai/api/search-image?query=Tech%20drama%20poster%20of%20a%20determined%20young%20engineer%20in%20a%20hoodie%20standing%20in%20a%20glass%20office%20at%20night%2C%20cool%20blue%20interior%20lighting%20with%20warm%20orange%20screen%20glow%2C%20clean%20minimal%20corporate%20background%2C%20modern%20Silicon%20Valley%20drama%20key%20art%2C%20ambitious%20cinematic%20mood&width=600&height=900&seq=drama-poster-d008&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=Modern%20tech%20campus%20at%20night%20with%20glowing%20glass%20buildings%2C%20deep%20blue%20tones%20and%20warm%20orange%20interior%20lights%20reflecting%20on%20pavement%2C%20cinematic%20wide%20shot%2C%20corporate%20drama%20key%20visual%2C%20sleek%20and%20futuristic%20atmosphere&width=1600&height=900&seq=drama-backdrop-d008&orientation=landscape',
    category: 'meiju',
    categoryName: '美剧',
    genres: ['剧情', '科技', '职场'],
    region: '美国',
    year: 2024,
    status: '已完结',
    episodes: 12,
    updatedTo: 12,
    updateInfo: '第一季已完结',
    updatedAt: '2026-09-15',
    rating: 8.5,
    heat: 4900000,
    starring: ['卢卡斯·里德','艾琳·陈','马库斯·凯恩'],
    director: '萨拉·米勒',
    tagline: '改变世界的野心，往往从一间车库开始。',
    synopsis:
      '三位年轻工程师怀揣颠覆行业的梦想创立了自己的公司。从车库到独角兽，他们经历融资博弈、内部裂痕与道德困境，在资本与人性的角力中，重新思考技术真正该为谁服务。',
    featured: false,
  },
  {
    id: 'd009',
    title: '长安夜行',
    poster:
      'https://readdy.ai/api/search-image?query=Ancient%20mystery%20drama%20poster%20of%20a%20cloaked%20investigator%20on%20a%20lantern-lit%20Chang%20an%20street%20at%20night%2C%20deep%20blue%20shadows%20with%20warm%20orange%20lantern%20glow%2C%20atmospheric%20cinematic%20composition%2C%20minimal%20misty%20background%2C%20historical%20suspense%20key%20art%2C%20elegant%20and%20mysterious&width=600&height=900&seq=drama-poster-d009&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=Grand%20ancient%20Chang%20an%20city%20street%20at%20night%20full%20of%20glowing%20red%20and%20orange%20lanterns%20under%20a%20deep%20blue%20sky%2C%20mysterious%20misty%20atmosphere%2C%20cinematic%20wide%20historical%20composition%2C%20suspenseful%20drama%20key%20visual%2C%20rich%20and%20atmospheric&width=1600&height=900&seq=drama-backdrop-d009&orientation=landscape',
    category: 'guzhuang',
    categoryName: '古装剧',
    genres: ['古装剧', '悬疑', '探案'],
    region: '大陆',
    year: 2025,
    status: '连载中',
    episodes: 30,
    updatedTo: 14,
    updateInfo: '每周四、周六更新 1 集',
    updatedAt: '2026-10-07',
    rating: 8.7,
    heat: 8120000,
    starring: ['沈砚青','柳如烟','裴明'],
    director: '杜衡',
    tagline: '长安城不眠，每一盏灯后都藏着秘密。',
    synopsis:
      '大理寺录事沈砚青因一桩离奇命案卷入长安城连环谜案。随着真相层层剥开，他发现案件背后牵扯着数年前的宫廷旧事。夜色之下，他必须在迷雾中找出那个真正执灯的人。',
    featured: false,
  },
  {
    id: 'd010',
    title: '麻辣闺蜜',
    poster:
      'https://readdy.ai/api/search-image?query=Cheerful%20urban%20comedy%20poster%20of%20three%20young%20women%20friends%20laughing%20together%20in%20a%20colorful%20city%20apartment%2C%20bright%20blue%20and%20warm%20orange%20accents%2C%20playful%20minimal%20background%2C%20contemporary%20friendship%20drama%20key%20art%2C%20lively%20and%20fun%20mood&width=600&height=900&seq=drama-poster-d010&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=Bright%20cozy%20city%20apartment%20interior%20with%20warm%20orange%20afternoon%20light%20and%20blue%20accents%2C%20cheerful%20modern%20lifestyle%20scene%2C%20cinematic%20wide%20composition%2C%20friendship%20comedy%20key%20visual%2C%20warm%20and%20inviting%20atmosphere&width=1600&height=900&seq=drama-backdrop-d010&orientation=landscape',
    category: 'dushi',
    categoryName: '都市剧',
    genres: ['都市', '喜剧', '友情'],
    region: '大陆',
    year: 2025,
    status: '连载中',
    episodes: 28,
    updatedTo: 12,
    updateInfo: '每周五更新 2 集',
    updatedAt: '2026-10-06',
    rating: 7.9,
    heat: 4210000,
    starring: ['苏小满','黄可','琪琪'],
    director: '吴桐',
    tagline: '生活很辣，但有你就不怕。',
    synopsis:
      '三个性格迥异的女孩合租在一间老小区公寓里，工作、爱情、家庭各有各的烦恼。她们在鸡飞狗跳的日常里互相扶持，用笑声对抗生活的麻辣，也收获了最珍贵的友情。',
    featured: false,
  },
  {
    id: 'd011',
    title: '雪域孤鹰',
    poster:
      'https://readdy.ai/api/search-image?query=Military%20historical%20drama%20poster%20of%20an%20armored%20general%20on%20a%20snowy%20mountain%20pass%2C%20cold%20blue%20snow%20tones%20with%20warm%20orange%20sunlight%20breaking%20through%2C%20epic%20cinematic%20composition%2C%20minimal%20harsh%20landscape%20background%2C%20Chinese%20war%20drama%20key%20art%2C%20heroic%20and%20solemn&width=600&height=900&seq=drama-poster-d011&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=Sweeping%20snowy%20mountain%20range%20at%20dawn%20with%20an%20army%20marching%20in%20the%20distance%2C%20cold%20blue%20snow%20and%20warm%20orange%20sunrise%2C%20cinematic%20epic%20wide%20shot%2C%20historical%20war%20drama%20key%20visual%2C%20majestic%20and%20solemn%20atmosphere&width=1600&height=900&seq=drama-backdrop-d011&orientation=landscape',
    category: 'guochan',
    categoryName: '国产剧',
    genres: ['古装剧', '军事', '历史'],
    region: '大陆',
    year: 2024,
    status: '已完结',
    episodes: 42,
    updatedTo: 42,
    updateInfo: '全剧已完结',
    updatedAt: '2026-09-05',
    rating: 8.3,
    heat: 5940000,
    starring: ['霍连山','叶清','马骁'],
    director: '高硕',
    tagline: '孤鹰守边关，一诺守山河。',
    synopsis:
      '镇守北境的将军霍连山在外敌压境与朝中猜忌的双重压力下，用一己之力守住边关。他与副将叶清并肩作战，在冰天雪地中书写了一段关于忠诚、信念与牺牲的壮阔史诗。',
    featured: false,
  },
  {
    id: 'd012',
    title: '财阀家的小女儿',
    poster:
      'https://readdy.ai/api/search-image?query=Elegant%20Korean%20family%20drama%20poster%20of%20a%20poised%20young%20heiress%20in%20a%20tailored%20suit%20before%20a%20grand%20mansion%20staircase%2C%20deep%20blue%20tones%20with%20warm%20orange%20accent%20light%2C%20refined%20minimal%20background%2C%20chaebol%20family%20drama%20key%20art%2C%20sophisticated%20and%20dramatic&width=600&height=900&seq=drama-poster-d012&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=Luxurious%20grand%20mansion%20interior%20with%20dramatic%20staircase%20and%20warm%20orange%20lighting%20against%20deep%20blue%20evening%20windows%2C%20cinematic%20wide%20shot%2C%20Korean%20chaebol%20family%20drama%20key%20visual%2C%20opulent%20and%20tense%20atmosphere&width=1600&height=900&seq=drama-backdrop-d012&orientation=landscape',
    category: 'hanju',
    categoryName: '韩剧',
    genres: ['剧情', '家族', '复仇'],
    region: '韩国',
    year: 2024,
    status: '已完结',
    episodes: 20,
    updatedTo: 20,
    updateInfo: '全剧已完结',
    updatedAt: '2026-08-30',
    rating: 8.6,
    heat: 6890000,
    starring: ['徐敏贞','姜泰旭','李慧琳'],
    director: '尹成浩',
    tagline: '被家族抛弃的那一天，她才真正开始战斗。',
    synopsis:
      '身为财阀家最小的女儿，瑞妍一直被当作家族的边缘人。在父亲突然离世、家产被兄姐瓜分后，她带着一份隐藏多年的证据重返集团，用冷静的头脑与惊人的毅力，展开了一场不动声色的夺权之战。',
    featured: false,
  },
  {
    id: 'd013',
    title: '边境线',
    poster:
      'https://readdy.ai/api/search-image?query=Action%20thriller%20poster%20of%20a%20border%20patrol%20agent%20standing%20on%20a%20dusty%20desert%20ridge%20at%20dusk%2C%20deep%20blue%20evening%20sky%20with%20warm%20orange%20dust%20light%2C%20gritty%20cinematic%20composition%2C%20minimal%20desolate%20background%2C%20tense%20American%20thriller%20key%20art%2C%20rugged%20atmosphere&width=600&height=900&seq=drama-poster-d013&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=Desolate%20desert%20border%20road%20at%20dusk%20with%20distant%20mountains%20and%20a%20lone%20vehicle%2C%20deep%20blue%20sky%20fading%20into%20warm%20orange%20horizon%2C%20cinematic%20wide%20thriller%20shot%2C%20dusty%20atmospheric%20composition%2C%20suspenseful%20and%20vast&width=1600&height=900&seq=drama-backdrop-d013&orientation=landscape',
    category: 'meiju',
    categoryName: '美剧',
    genres: ['动作', '惊悚', '犯罪'],
    region: '美国',
    year: 2025,
    status: '连载中',
    episodes: 8,
    updatedTo: 4,
    updateInfo: '每周日更新 1 集',
    updatedAt: '2026-10-05',
    rating: 8.1,
    heat: 3760000,
    starring: ['杰克·桑德斯','莉娜·莫拉莱斯','卡尔·弗莱明'],
    director: '丹尼尔·福特',
    tagline: '在那条线上，对错从来都不简单。',
    synopsis:
      '经验丰富的边境巡警在一次例行巡逻中发现了不寻常的走私线索。随着调查推进，他逐渐意识到自己所在的系统远比想象中复杂。当正义与规则发生冲突，他必须做出自己的选择。',
    featured: false,
  },
  {
    id: 'd014',
    title: '半糖时光',
    poster:
      'https://readdy.ai/api/search-image?query=Romantic%20urban%20drama%20poster%20of%20a%20young%20woman%20holding%20a%20cup%20of%20milk%20tea%20on%20a%20cozy%20city%20street%2C%20soft%20blue%20evening%20tones%20with%20warm%20orange%20cafe%20light%2C%20gentle%20film%20mood%2C%20minimal%20urban%20background%2C%20sweet%20modern%20romance%20key%20art%2C%20warm%20and%20tender&width=600&height=900&seq=drama-poster-d014&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=Cozy%20city%20cafe%20street%20in%20the%20evening%20with%20warm%20orange%20sign%20lights%20and%20deep%20blue%20twilight%2C%20cinematic%20wide%20composition%2C%20gentle%20romantic%20urban%20atmosphere%2C%20modern%20drama%20key%20visual%2C%20soft%20and%20inviting&width=1600&height=900&seq=drama-backdrop-d014&orientation=landscape',
    category: 'dushi',
    categoryName: '都市剧',
    genres: ['都市', '爱情', '生活'],
    region: '大陆',
    year: 2025,
    status: '连载中',
    episodes: 24,
    updatedTo: 16,
    updateInfo: '每周二、周三更新 2 集',
    updatedAt: '2026-10-04',
    rating: 8.0,
    heat: 3980000,
    starring: ['林甜甜','程屿','周沫'],
    director: '江嘉',
    tagline: '生活要有甜度，也要刚刚好。',
    synopsis:
      '奶茶店主理人甜甜把小小的店面打理得有声有色，却始终放不下年少时的一段遗憾。当旧日好友重新出现在她的城市，她开始学着在生活的苦与甜之间，找到属于自己的平衡。',
    featured: false,
  },
  {
    id: 'd015',
    title: '御膳房秘事',
    poster:
      'https://readdy.ai/api/search-image?query=Ancient%20palace%20drama%20poster%20of%20a%20young%20female%20chef%20in%20elegant%20Chinese%20robes%20in%20a%20grand%20imperial%20kitchen%2C%20warm%20orange%20firelight%20against%20deep%20blue%20shadows%2C%20cinematic%20detailed%20composition%2C%20minimal%20textured%20background%2C%20historical%20food%20drama%20key%20art%2C%20refined%20and%20warm&width=600&height=900&seq=drama-poster-d015&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=Grand%20ancient%20Chinese%20imperial%20kitchen%20with%20copper%20woks%20and%20glowing%20fire%2C%20warm%20orange%20light%20against%20deep%20blue%20shadows%2C%20cinematic%20wide%20shot%2C%20detailed%20historical%20composition%2C%20palace%20culinary%20drama%20key%20visual%2C%20rich%20and%20atmospheric&width=1600&height=900&seq=drama-backdrop-d015&orientation=landscape',
    category: 'guzhuang',
    categoryName: '古装剧',
    genres: ['古装剧', '美食', '成长'],
    region: '大陆',
    year: 2024,
    status: '已完结',
    episodes: 26,
    updatedTo: 26,
    updateInfo: '全剧已完结',
    updatedAt: '2026-08-22',
    rating: 8.2,
    heat: 4470000,
    starring: ['姜小厨','柳若薇','傅怀'],
    director: '冯启',
    tagline: '一道菜，也能藏着一整座宫城的秘密。',
    synopsis:
      '出身民间的少女姜小厨凭借一手好厨艺进入御膳房。在等级森严的深宫里，她用一道道精心烹制的菜肴化解风波、结交知己，也意外卷入了一场关乎宫廷安危的隐秘事件。',
    featured: false,
  },
  {
    id: 'd016',
    title: '汉江月夜',
    poster:
      'https://readdy.ai/api/search-image?query=Korean%20historical%20drama%20poster%20of%20a%20noble%20scholar%20in%20traditional%20hanbok%20standing%20by%20a%20moonlit%20river%2C%20deep%20blue%20night%20tones%20with%20warm%20orange%20lantern%20glow%2C%20elegant%20cinematic%20composition%2C%20minimal%20misty%20background%2C%20period%20drama%20key%20art%2C%20graceful%20and%20poetic&width=600&height=900&seq=drama-poster-d016&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=Serene%20moonlit%20river%20at%20night%20with%20traditional%20Korean%20pavilion%20and%20floating%20lanterns%2C%20deep%20blue%20water%20and%20warm%20orange%20lights%2C%20cinematic%20wide%20historical%20composition%2C%20poetic%20period%20drama%20key%20visual%2C%20tranquil%20and%20elegant&width=1600&height=900&seq=drama-backdrop-d016&orientation=landscape',
    category: 'hanju',
    categoryName: '韩剧',
    genres: ['历史', '剧情', '爱情'],
    region: '韩国',
    year: 2025,
    status: '连载中',
    episodes: 18,
    updatedTo: 9,
    updateInfo: '每周一、周二更新 1 集',
    updatedAt: '2026-10-03',
    rating: 8.5,
    heat: 5230000,
    starring: ['李瑞俊','金素妍','张赫'],
    director: '朴尚勋',
    tagline: '月照汉江，照见多少未说出口的心事。',
    synopsis:
      '动荡年代里，一位出身没落士族的学者与一位心怀家国的女子在汉江边相遇。两人在时代的洪流中彼此扶持，用诗文与信念守护心中所爱，也见证了一个王朝的兴衰更替。',
    featured: false,
  },
  {
    id: 'd017',
    title: '深空回响',
    poster:
      'https://readdy.ai/api/search-image?query=Sci-fi%20drama%20poster%20of%20an%20astronaut%20silhouette%20before%20a%20vast%20glowing%20cosmic%20nebula%2C%20deep%20blue%20space%20with%20warm%20orange%20energy%20flares%2C%20cinematic%20epic%20composition%2C%20minimal%20starfield%20background%2C%20space%20adventure%20key%20art%2C%20awe%20inspiring%20and%20futuristic&width=600&height=900&seq=drama-poster-d017&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=Epic%20deep%20space%20scene%20with%20a%20small%20spacecraft%20drifting%20toward%20a%20glowing%20nebula%2C%20deep%20blue%20cosmos%20with%20warm%20orange%20energy%2C%20cinematic%20wide%20composition%2C%20sci-fi%20adventure%20key%20visual%2C%20vast%20and%20mysterious%20atmosphere&width=1600&height=900&seq=drama-backdrop-d017&orientation=landscape',
    category: 'meiju',
    categoryName: '美剧',
    genres: ['科幻', '冒险', '悬疑'],
    region: '美国',
    year: 2025,
    status: '连载中',
    episodes: 10,
    updatedTo: 7,
    updateInfo: '每周三更新 1 集',
    updatedAt: '2026-10-02',
    rating: 9.0,
    heat: 7420000,
    starring: ['艾拉·诺瓦克','本·卡特','蕾切尔·吴'],
    director: '乔纳森·派克',
    tagline: '宇宙的尽头，藏着一个我们早已问过的问题。',
    synopsis:
      '一支深空探索队在距离地球数十光年的星系收到了来自未知来源的重复信号。随着解码推进，队员们发现这个信号似乎与人类文明的起源有关，而真相将彻底改变他们对宇宙的认知。',
    featured: false,
  },
  {
    id: 'd018',
    title: '写字楼的春天',
    poster:
      'https://readdy.ai/api/search-image?query=Inspiring%20workplace%20drama%20poster%20of%20a%20young%20man%20and%20woman%20collaborating%20in%20a%20bright%20modern%20office%2C%20cool%20blue%20tones%20with%20warm%20orange%20morning%20light%2C%20clean%20minimal%20interior%20background%2C%20uplifting%20contemporary%20drama%20key%20art%2C%20energetic%20and%20hopeful%20mood&width=600&height=900&seq=drama-poster-d018&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=Bright%20modern%20open%20office%20with%20large%20glass%20windows%20and%20warm%20orange%20morning%20sunlight%2C%20cool%20blue%20interior%20accents%2C%20cinematic%20wide%20composition%2C%20uplifting%20workplace%20drama%20key%20visual%2C%20clean%20and%20hopeful%20atmosphere&width=1600&height=900&seq=drama-backdrop-d018&orientation=landscape',
    category: 'dushi',
    categoryName: '都市剧',
    genres: ['都市', '职场', '励志'],
    region: '大陆',
    year: 2024,
    status: '已完结',
    episodes: 30,
    updatedTo: 30,
    updateInfo: '全剧已完结',
    updatedAt: '2026-08-18',
    rating: 7.8,
    heat: 3350000,
    starring: ['程一鸣','苏晴','浩然'],
    director: '刘峰',
    tagline: '梦想也许会迟到，但从不缺席。',
    synopsis:
      '两个来自不同背景的年轻人在一家创业公司相遇，从针锋相对的同事变成并肩作战的伙伴。在一次次项目的成败起伏中，他们学会了成长，也找到了属于自己的春天。',
    featured: false,
  },
  {
    id: 'd019',
    title: '少年游侠传',
    poster:
      'https://readdy.ai/api/search-image?query=Youthful%20wuxia%20drama%20poster%20of%20a%20spirited%20teenage%20swordsman%20on%20a%20rooftop%20under%20a%20blue%20sky%20with%20warm%20orange%20clouds%2C%20dynamic%20cinematic%20composition%2C%20minimal%20bright%20background%2C%20coming%20of%20age%20martial%20arts%20key%20art%2C%20fresh%20and%20energetic&width=600&height=900&seq=drama-poster-d019&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=Sweeping%20wuxia%20scene%20of%20young%20swordsmen%20training%20on%20a%20mountain%20plateau%20under%20warm%20orange%20sunset%20and%20deep%20blue%20sky%2C%20dynamic%20cinematic%20wide%20shot%2C%20youth%20martial%20arts%20drama%20key%20visual%2C%20bright%20and%20spirited%20atmosphere&width=1600&height=900&seq=drama-backdrop-d019&orientation=landscape',
    category: 'guzhuang',
    categoryName: '古装剧',
    genres: ['古装剧', '武侠', '青春'],
    region: '大陆',
    year: 2025,
    status: '连载中',
    episodes: 34,
    updatedTo: 18,
    updateInfo: '每周六、周日更新 2 集',
    updatedAt: '2026-10-01',
    rating: 8.1,
    heat: 4580000,
    starring: ['萧然','伊一','方远'],
    director: '罗晋',
    tagline: '少年不知江湖险，一腔热血走天涯。',
    synopsis:
      '心怀侠义的少年萧然离开家乡闯荡江湖，一路结识了性格各异的同伴。他们从懵懂少年成长为担当重任的侠客，在快意恩仇之间，写下属于新一代的江湖传说。',
    featured: false,
  },
  {
    id: 'd020',
    title: '济州岛来信',
    poster:
      'https://readdy.ai/api/search-image?query=Healing%20Korean%20drama%20poster%20of%20a%20young%20woman%20sitting%20on%20a%20scenic%20Jeju%20island%20cliff%20with%20the%20sea%20behind%20her%2C%20soft%20blue%20ocean%20tones%20with%20warm%20orange%20sunset%2C%20gentle%20cinematic%20mood%2C%20minimal%20natural%20background%2C%20emotional%20healing%20drama%20key%20art%2C%20serene%20and%20warm&width=600&height=900&seq=drama-poster-d020&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=Beautiful%20Jeju%20island%20coastline%20at%20golden%20hour%20with%20rocky%20cliffs%20and%20calm%20blue%20sea%2C%20warm%20orange%20sunset%20glow%2C%20cinematic%20wide%20composition%2C%20tranquil%20healing%20drama%20key%20visual%2C%20peaceful%20and%20inviting%20atmosphere&width=1600&height=900&seq=drama-backdrop-d020&orientation=landscape',
    category: 'hanju',
    categoryName: '韩剧',
    genres: ['治愈', '爱情', '生活'],
    region: '韩国',
    year: 2025,
    status: '连载中',
    episodes: 16,
    updatedTo: 11,
    updateInfo: '每周四更新 1 集',
    updatedAt: '2026-09-30',
    rating: 8.7,
    heat: 6120000,
    starring: ['文素恩','李在贤','高允儿'],
    director: '韩智秀',
    tagline: '每一封信，都是一次温柔的重逢。',
    synopsis:
      '因为工作受挫，素恩回到外婆留下的济州岛老屋生活。一次整理旧物时，她发现了一叠从未寄出的信，也由此结识了负责修缮老屋的青年。海风与信笺之间，她慢慢疗愈了自己，也重新相信了爱。',
    featured: false,
  },
];

export const featuredDramas = dramas.filter((d) => d.featured);

export const getDramaById = (id: string) => dramas.find((d) => d.id === id);

export const getDramasByCategory = (slug: string) => dramas.filter((d) => d.category === slug);

export const getDramasByGenre = (genre: string) => dramas.filter((d) => d.genres.includes(genre));

export const latestDramas = [...dramas].sort((a, b) => (a.updatedAt < b.updatedAt ? 1 : -1));

export const hotDramas = [...dramas].sort((a, b) => b.heat - a.heat);

export const regions = ['大陆', '韩国', '美国'];
export const years = [2025, 2024, 2023];
export const statuses = ['连载中', '已完结'];